module.exports = __webpack_public_path__ + "static/media/bg-methods.8ab4cd60.jpg";